import { type RouteRecordRaw } from 'vue-router'

export const ValidationMailSentRouter: RouteRecordRaw[] = [
  {
    path: '/ValidationMailSent',
    component: async () => import('./ValidationMailSent.vue'),
  },
]
